import React from 'react'
import { Text, UnstyledButton } from '@mantine/core'

const AccountSettingsCard = ({
	name,
	email,
	onClick,
	fullWidth = false,
	ariaLabel = 'Open account settings',
}) => {
	return (
		<UnstyledButton
			type='button'
			onClick={onClick}
			aria-label={ariaLabel}
			sx={(theme) => ({
				display: 'block',
				width: fullWidth ? '100%' : 'auto',
				backgroundColor:
					theme.colorScheme === 'dark'
						? theme.colors.dark[6]
						: theme.colors.gray[1],
				borderRadius: theme.radius.md,
				padding: `5px ${theme.spacing.sm}`,
				border: `1px solid ${
					theme.colorScheme === 'dark'
						? theme.colors.dark[4]
						: theme.colors.gray[3]
				}`,
				textAlign: 'left',
			})}
		>
			<Text size='sm' weight={600} lineClamp={1}>
				{name || 'Account'}
			</Text>
			<Text size='xs' color='dimmed' lineClamp={1}>
				{email || 'No email'}
			</Text>
		</UnstyledButton>
	)
}

export default AccountSettingsCard
